import Alert from '@mui/joy/Alert'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import type { LaterAvailabilityTime } from '../types'

export default function LaterAvailabilityGuidance({
    availableTimes,
    onSelectStartTime,
}: {
    availableTimes: Array<LaterAvailabilityTime>,
    onSelectStartTime: (startTime: LaterAvailabilityTime) => void,
}) {
    const { t } = useTranslation()
    const earliestAvailableTime = availableTimes[0]

    if (!earliestAvailableTime) return null

    return (
        <Alert
            variant="outlined"
            color="warning"
            sx={{
                width: '100%',
                maxWidth: '30rem',
                mx: 'auto',
                backgroundColor: 'var(--joy-palette-secondary-100)',
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Typography level="body-sm" sx={{ color: 'black', textAlign: 'center' }}>
                    {t('general.garageAvailableLaterDetail', {
                        time: earliestAvailableTime,
                    })}
                </Typography>
                <Box sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: 1,
                    mt: 1,
                }}>
                    <Button
                        variant="solid"
                        size="sm"
                        onClick={() => onSelectStartTime(earliestAvailableTime)}
                    >
                        {t('general.setStartToTime', { time: earliestAvailableTime })}
                    </Button>
                </Box>
            </Box>
        </Alert>
    )
}
